import { useControllableValue } from 'ahooks';
import classNames from 'classnames';
import React from 'react';
import { getAppIcon, Platform } from '@/infrastructure/utils/app';
import { StandardFormType } from '@/presentation/components/form/standards/types';
import styles from '@/presentation/components/pro-app-list/style.module.scss';

type IProps = StandardFormType &{platformOptions: {label: string, value: Platform, hidden?: boolean}[]};

export const AppListFormItem = (props: IProps) => {
  const { platformOptions } = props;
  const [state, setState] = useControllableValue<Platform>(props, {
    defaultValue: undefined,
  });

  const change = (value: Platform) => {
    setState(value);
  };

  return <div className={classNames(styles.platformContainer)}>
    {platformOptions.filter(opt => !opt.hidden).map((opt) => {
      const checked = state === opt.value;
      return (
        <div
          key={opt.value}
          className={classNames(styles.platforms, checked ? styles.active : '')}
          onClick={() => change(opt.value)}
        >
          <span>{getAppIcon(`${opt.value}`)}</span>
          <span>{opt.label}</span>
        </div>
      );
    })}
  </div>;
};
